import type { ReactNode } from 'react'

import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

export interface ToolCallSectionProps {
  title: string
  content: string
  className?: string
  isError?: boolean
}

export const ToolCallSection: React.FC<ToolCallSectionProps> = ({
  title,
  content,
  className,
  isError = false,
}): ReactNode => (
  <>
    <Separator />
    <div className={cn('tool-call-section', className)}>
      <h3 className={cn('mb-2 text-sm font-semibold', isError && 'text-destructive')}>{title}</h3>
      <Card className={cn(isError && 'border-destructive/50')}>
        <CardContent className="p-3">
          <pre
            className={cn(
              'whitespace-pre-wrap text-sm',
              isError ? 'text-destructive' : 'text-muted-foreground'
            )}
          >
            {content}
          </pre>
        </CardContent>
      </Card>
    </div>
  </>
)
